import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochiKidReceiptDetailData = receiptId =>
  axios.get(`${API_HOST}/gochi-kid/receipt/${receiptId}`, {
    withCredentials: true
  });

export const getGochiKidReceiptListData = params =>
  axios.get(`${API_HOST}/gochi-kid/receipt`, {
    params,
    withCredentials: true
  });

export const confirmReceiptData = params =>
  axios.post(`${API_HOST}/gochi-kid/confirm-receipt`, params, {
    withCredentials: true
  });

export const settingGochiKidReceiptGroupData = params =>
  axios.put(`${API_HOST}/gochi-kid/setting-receipt-group`, params, {
    withCredentials: true
  });

export const settingGochiKidReceiptShopData = params =>
  axios.put(`${API_HOST}/gochi-kid/setting-receipt-shop`, params, {
    withCredentials: true
  });
